import { Link } from 'react-router-dom';
import {
  Card,
  CardFooter,
  CardHeader,
  CardContent,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { categoryIcons } from '@Constants/iconMap';
import { Workspace } from '@Types/workspace';

interface WorkspaceCardProps {
  workspace: Workspace;
}

export default function WorkspaceCard({ workspace }: WorkspaceCardProps) {
  const wsColor = workspace.color ?? 'red-500';
  const wsIcon = categoryIcons[workspace.icon];

  return (
    <Card
      className="flex h-75 flex-col border-t-40 pt-0"
      style={{ borderTopColor: wsColor }}
    >
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex w-full justify-end pr-4">
          <div className="-mt-5 rounded-3xl bg-white p-4">{wsIcon?.icon}</div>
        </div>

        <CardHeader className="flex flex-col gap-0">
          <Heading level="h4" className="text-ellipsis">
            {workspace.name}
          </Heading>
          <p className="line-clamp-2 text-xs">{workspace.description}</p>
        </CardHeader>

        <CardContent className="min-h-0 flex-1 overflow-auto rounded-md py-2">
          {workspace.dashboards && workspace.dashboards.length > 0 && (
            <div>
              <div className="mb-1 flex items-center gap-2">
                <span className="text-muted-foreground text-xs font-medium tracking-wide uppercase">
                  Dashboards
                </span>
                <span className="bg-muted border-border text-muted-foreground rounded-full border px-2 py-0.5 text-xs">
                  {workspace.dashboards.length}
                </span>
              </div>
              <div className="ml-2 flex h-full flex-col gap-1">
                {workspace.dashboards.map((db) => (
                  <div key={db.dashboard?.id}>
                    <Link
                      to={`/workspaces/cards/${workspace.id}?dashboard=${db.dashboard?.id}`}
                      className="text-muted-foreground flex w-fit items-center gap-2 rounded-md text-sm hover:text-black"
                    >
                      <span
                        className="h-1.5 w-1.5 flex-shrink-0 rounded-full"
                        style={{ backgroundColor: wsColor }}
                      />
                      <span className="truncate text-xs">
                        {db.dashboard?.name}
                      </span>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          )}
        </CardContent>
      </div>

      <CardFooter className="shrink-0">
        <Button asChild variant="secondary">
          <Link to={`/workspaces/cards/${workspace.id}`}>View Workspace</Link>
        </Button>
      </CardFooter>
    </Card>
  );
}
